import { configureStore } from '@reduxjs/toolkit';

import accountsReducer from '../features/manageAccounts/accountsSlice.js';
import transactionsReducer from '../features/transactionList/transactionsSlice.js';
import transferReducer from '../features/transfer/transferSlice.js';
import loginReducer from '../features/login/loginSlice.js';
import signupReducer from '../features/signup/signupSlice.js';
import menuReducer from '../features/menu/menuSlice.js';
import displayNameReducer from '../features/editDisplayNameForm/displayNameSlice.js';
import changePasswordFormReducer from '../features/changePasswordForm/changePasswordFormSlice.js';
import depositFormReducer from '../features/depositForm/depositSlice.js';
import manageUsersReducer from '../features/manageUsers/manageUsersSlice.js';
import createUserFormReducer from '../features/createUserForm/createUserFormSlice.js';
import editUserFormReducer from '../features/editUserForm/editUserFormSlice.js';
import branchesReducer from '../features/manageBranches/branchesSlice.js';
import createBranchFormReducer from '../features/createBranchForm/createBranchFormSlice.js';
import editBranchFormReducer from '../features/editBranchForm/editBranchFormSlice.js';
import createAccountFormReducer from '../features/createAccountForm/createAccountFormSlice.js';
import bankSettingsReducer from '../features/manageBankSettings/bankSettingsSlice.js';
import userReducer from '../features/home/userSlice.js';
import withdrawalFormReducer from '../features/withdrawalForm/withdrawalFormSlice.js';
import statementsReducer from '../features/statements/statementsSlice.js';
import editTransactionFormReducer from '../features/editTransactionForm/editTransactionFormSlice.js';
import supportTicketsReducer from '../features/supportTickets/supportTicketsSlice.js';
import supportTicketFormReducer from '../features/supportTicketForm/supportTicketFormSlice.js';
import commentFormReducer from '../features/commentForm/commentFormSlice.js';
import searchBarReducer from '../features/searchBar/searchBarSlice.js';
import manageBanksReducer from '../features/manageBanks/manageBanksSlice.js';
import bulkTransactionsReducer from '../features/bulkTransactionsForm/bulkTransactionsSlice.js'

export const store = configureStore({
  reducer: {
    accounts: accountsReducer,
    createAccountForm: createAccountFormReducer,
    transactions: transactionsReducer,
    transfer: transferReducer,
    login: loginReducer,
    signup: signupReducer,
    menu: menuReducer,
    displayName: displayNameReducer,
    changePasswordForm: changePasswordFormReducer,
    deposit: depositFormReducer,
    user: userReducer,
    users: manageUsersReducer,
    createUserForm: createUserFormReducer,
    editUserForm: editUserFormReducer,
    branches: branchesReducer,
    createBranchForm: createBranchFormReducer,
    editBranchForm: editBranchFormReducer,
    bankSettings: bankSettingsReducer,
    withdrawal: withdrawalFormReducer,
    statements: statementsReducer,
    editTransactionForm: editTransactionFormReducer,
    supportTickets: supportTicketsReducer,
    supportTicketForm: supportTicketFormReducer,
    commentForm: commentFormReducer,
    searchBar: searchBarReducer,
    manageBanks: manageBanksReducer,
    bulkTransactions: bulkTransactionsReducer
  }
});